module.exports = __webpack_public_path__ + "img/assignment_ind.3cd022c9.svg";